var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewscene3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 677,
    height: 676,
    viewBox: "0 0 677 676",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_823_5739)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 676.001,
    height: 675,
    transform: "translate(0 0.25)",
    fill: "#F68712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.028 456.219C639.023 442.601 596.138 427.811 553.404 411.831C494.69 389.606 437.251 365.503 381.144 339.625C448.983 270.986 512.962 199.274 572.981 124.808C607.98 173.221 644.354 220.316 682.028 266.06V-19.649C682.038 -19.6634 682.038 -19.6634 682.038 -19.6634L682.028 456.219ZM0.0834961 123.457C0.0834961 58.35 0.0834961 -6.64844 0.0834961 -69.8481C0.0834961 -69.8481 0.0865435 -69.8481 0.0935098 -69.8481C0.0935098 -5.4783 0.0935098 59.7937 0.0935098 123.463",
    fill: "url(#paint0_linear_823_5739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.028 266.055C644.354 220.31 607.98 173.215 572.981 124.802C610.936 77.7095 647.298 29.5264 682.038 -19.6692L682.028 266.055Z",
    fill: "url(#paint1_linear_823_5739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0935059 662.91C0.0935059 662.91 0.0935059 409.1 0.0935059 123.46C119.042 204.917 246.259 277.409 381.144 339.622C265.145 456.989 137.89 565.346 0.0935059 662.91ZM682.037 -19.6655L682.038 -69.8514L682.037 -19.6655C682.038 -19.6666 682.038 -19.6666 682.038 -19.6666L682.037 -19.6655Z",
    fill: "#F14A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.144 339.621C246.259 277.408 119.042 204.916 0.0834961 123.453C0.0935098 59.7899 0.0935098 -5.48212 0.0935098 -69.852C2.39938 -69.852 396.407 -69.852 682.038 -69.852L682.037 -19.666C682.038 -19.6671 682.038 -19.6672 682.038 -19.6672L682.028 -69.852C559.262 -69.852 444.1 -69.852 444.1 -69.852C484.641 -2.79883 527.657 62.1092 572.981 124.804C512.962 199.27 448.983 270.982 381.144 339.621Z",
    fill: "url(#paint2_linear_823_5739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.981 124.805C527.657 62.1101 484.64 -2.79796 444.1 -69.8511C444.1 -69.8511 559.262 -69.8511 682.028 -69.8511V-19.652C647.298 29.5292 610.935 77.7123 572.981 124.805Z",
    fill: "url(#paint3_linear_823_5739)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_823_5739",
    x1: -252.106,
    y1: -4350.1,
    x2: 423.353,
    y2: 740.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D7224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5F6D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E642F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_823_5739",
    x1: -252.106,
    y1: -4350.11,
    x2: 423.353,
    y2: 740.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3C3119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B2E1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_823_5739",
    x1: -252.107,
    y1: -4350.11,
    x2: 423.353,
    y2: 740.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#904627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#66472E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65432E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_823_5739",
    x1: -252.107,
    y1: -4350.1,
    x2: 423.352,
    y2: 740.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#582116"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3F2219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2119"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_823_5739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 676.001,
    height: 675,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewscene3);
export default __webpack_public_path__ + "static/media/newscene3.6fd4725dee7f45060773b83e2b95803a.svg";
export { ForwardRef as ReactComponent };